module.exports = __webpack_public_path__ + "assets/img/how-to-donate-mobile-img-1.bff461fb.jpg";